module.exports = __webpack_public_path__ + "img/timeline_miscevent-2.b0ce52a4.jpg";